/**
 * Per-locale text overlays for the driver-facing content in this
 * package — the manual pages and the changelog.
 *
 * SHAPE CONTRACT (localization pipeline, 2026-07-31):
 * - Overlays carry TRANSLATED TEXT ONLY: title / summary / body for
 *   manual pages, title / body for changelog entries. slug, audience
 *   and related stay single-source in index.ts — slug is the identity
 *   contract for /help/<slug> routes, cross-links and EVII's
 *   suggest_manual_page, and cloning whole page arrays per locale
 *   would let structure drift.
 * - Manual overlays are keyed by SLUG. Changelog overlays are keyed
 *   by the entry's ISO DATE, with '#N' appended for the second and
 *   later entries sharing a date, in array order ('2026-07-03', then
 *   '2026-07-03#2'). Same-date order is therefore part of the
 *   identity: append new entries at the top, never reorder a
 *   same-date group.
 * - Resolution falls back PER KEY to English: a missing or empty key
 *   renders the English text, so a partial translation degrades
 *   gracefully and en ships complete while the other ten fill in.
 * - en.json is GENERATED from index.ts (npm run content:en-overlay)
 *   and is the translators' reference file: copy it to <locale>.json
 *   and replace the values. Never hand-edit en.json; regenerate it.
 * - Explicit static imports, NOT a glob: this package is consumed by
 *   the api (plain Node) as well as the web app, and glob imports
 *   are a Vite-only feature.
 */
import en from './en.json' with { type: 'json' };
import es from './es.json' with { type: 'json' };
import fr from './fr.json' with { type: 'json' };
import hy from './hy.json' with { type: 'json' };
import it from './it.json' with { type: 'json' };
import ja from './ja.json' with { type: 'json' };
import ko from './ko.json' with { type: 'json' };
import pt from './pt.json' with { type: 'json' };
import ru from './ru.json' with { type: 'json' };
import uk from './uk.json' with { type: 'json' };
import zh from './zh.json' with { type: 'json' };
export const CONTENT_OVERLAYS = {
    en: en,
    es: es,
    fr: fr,
    hy: hy,
    it: it,
    ja: ja,
    ko: ko,
    pt: pt,
    ru: ru,
    uk: uk,
    zh: zh,
};
//# sourceMappingURL=registry.js.map